import React from 'react';
import { IOldIconProps } from './type';

const BankCard: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 459.669 459.669"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      {...props}
    >
      <g>
        <g>
          <path
            d="M404.723,76.087H54.947C24.648,76.087,0,100.735,0,131.035v197.599c0,30.298,24.648,54.948,54.947,54.948h349.775
        c30.297,0,54.947-24.65,54.947-54.948V131.035C459.67,100.735,435.02,76.087,404.723,76.087z M429.266,328.633
        c0,13.534-11.01,24.544-24.543,24.544H54.947c-13.533,0-24.545-11.01-24.545-24.544V196.214h398.863L429.266,328.633
        L429.266,328.633z M429.266,152.839l-398.863,0.029v-21.834c0-13.534,11.012-24.545,24.545-24.545h349.775
        c13.533,0,24.543,11.011,24.543,24.545V152.839z"
          />
          <path
            d="M68.135,324.98h83.23c2.98,0,5.398-2.416,5.398-5.396v-16.421c0-2.981-2.418-5.397-5.398-5.397h-83.23
        c-2.98,0-5.398,2.416-5.398,5.397v16.421C62.736,322.564,65.154,324.98,68.135,324.98z"
          />
          <path
            d="M312.363,249.025c8.649,0,16.621,2.897,23.006,7.768c6.385-4.869,14.354-7.768,23.006-7.768
        c20.975,0,37.979,17.004,37.979,37.979s-17.005,37.977-37.979,37.977c-8.65,0-16.621-2.896-23.006-7.768
        c-6.385,4.871-14.355,7.768-23.006,7.768c-20.976,0-37.979-17.002-37.979-37.977S291.389,249.025,312.363,249.025z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default BankCard;
